import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
import {clusterTableReady,rowsPerPageState,searchTextState,paginationState,clusterIdForAction} from '../redux/clusters'
import { headerDataUpdate,subHeaderDataUpdate, expiryTokenlogout, buildNumberUpdate } from '../../../redux/user'
import { SearchField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/clusterTable.css'


import { CSVLink } from 'react-csv'
import { createXLSheetdata } from '../services/helpers'


import moment from 'moment'


import KitchensCollapsibleRow from './KitchensCollapsibleRow'

import * as Helpers from '../../../common/helpers'

function filterExportData(clustersData) {

    
    let newArray = []
    if (clustersData.length > 0) {
        for (let i = 0; i < clustersData.length; i++) {

            if(clustersData[i].kitchens.length>0){
                for (let j = 0; j < clustersData[i].kitchens.length; j++) {
                    let newLineData = {}
                    let lineData = clustersData[i]
                    newLineData.id = lineData.id;
                    newLineData.cluster_name = lineData.cluster_name
                    newLineData.cluster_code = lineData.cluster_code
                    newLineData.manager_name = lineData.manager_name
                    newLineData.city_name = lineData.city_name
                    newLineData.kitchen_code = lineData.kitchens[j].kitchen_code
                    newLineData.kitchen_name = lineData.kitchens[j].kitchen_name
                    newLineData.kitchen_manager_name = lineData.kitchens[j].kitchen_manager_name  
                    newArray.push(newLineData)       
                }
            }else{
                let newLineData = {}
                let lineData = clustersData[i]
                newLineData.id = lineData.id;
                newLineData.cluster_name = lineData.cluster_name;
                newLineData.cluster_code = lineData.cluster_code;
                newLineData.manager_name = lineData.manager_name;
                newLineData.city_name = lineData.city_name  
                newArray.push(newLineData)     
            
            }

        }
    }
    return newArray
}


function filterUnwantedData(clustersData) {
    let array = []
    if (clustersData && clustersData.data && clustersData.data.list) {
        array = clustersData.data.list
    }

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let newLineData = {}
            let lineData = array[i]
            newLineData.id = lineData.id ? lineData.id : ""
            newLineData.cluster_name = lineData.name ? lineData.name : "NA"
            newLineData.cluster_code = lineData.code ? lineData.code : "NA"
            newLineData.manager_name = lineData.cluster_manager.name ? lineData.cluster_manager.name : "NA"
            newLineData.city_name = lineData.city.name ? lineData.city.name : "NA"
            newLineData.city_id = lineData.city_id ? lineData.city_id : ""


            let kitchens = []
            if(lineData.kitchens){
                for (let j = 0; j < lineData.kitchens.length; j++) {
                    kitchens[j]={
                        "kitchen_id":lineData.kitchens[j].id,
                        "kitchen_name":lineData.kitchens[j].name ? lineData.kitchens[j].name : "NA",
                        "kitchen_code": lineData.kitchens[j].code ? lineData.kitchens[j].code : "NA",
                        "kitchen_manager_name":lineData.kitchens[j].kitchen_manager && lineData.kitchens[j].kitchen_manager.name && lineData.kitchens[j].kitchen_manager.name ? lineData.kitchens[j].kitchen_manager.name +" - "+lineData.kitchens[j].kitchen_manager.code : "NA",
                        "cluster_name":newLineData.cluster_name,
                        "cluster_code":newLineData.cluster_code,
                        "city_name":newLineData.city_name,
                        "city_id":newLineData.city_id,
                        "cluster_id":lineData.id
                        }                    
                }
            }
            newLineData.kitchens=kitchens;

            newArray[i] = newLineData
        }
    }
    return newArray
}


class ClustersTable extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            clusterData: [],
            bodyHeight: "0px",
            tableHeight: "0px",
            rowCount: 15,
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: ""
        }
        this.isComponentMounted = true
        this.dialog = null
        this.searchBox = null


        this.CSVData = []
        this.createCSVData = this.createCSVData.bind(this)
    }

    componentWillMount() {
        this.isComponentMounted = true
        this.props.dispatch(clusterTableReady(false))
        this.props.dispatch(headerDataUpdate(Constants.CLUSTERS_TABLE))        
        this.props.dispatch(subHeaderDataUpdate())

        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()

        this.getClustersData()
        
    }

    componentDidMount() {
    }
    
    updateDimensions = () => {
        this.setState({
            tableHeight: (window.innerHeight - 230) + "px",
            bodyHeight: (window.innerHeight - 65) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }
    
    getClustersData = () => {
        apiService.getClustersData()
            .then(clustersData => {
                if (clustersData && this.isComponentMounted) {
                    this.validateBuildNumber(clustersData)
                    if (clustersData.status === "SUCCESS") {
                        let array = filterUnwantedData(clustersData), pageNo = 1
                        if (this.props.clusters && this.props.clusters.previousPaginationValue) {
                            pageNo = this.props.clusters.previousPaginationValue
                        }
                        this.setState({
                            clusterData: array,
                            page: pageNo,
                        })


                        let exportData=filterExportData(array)

                        this.createCSVData(exportData)

                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: clustersData.reason ? clustersData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                }
                this.props.dispatch(clusterTableReady(true))
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(clusterTableReady(true))
                if (this.isComponentMounted) {
                    this.props.dispatch(expiryTokenlogout(false))
                }
            })
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.clusters && this.props.clusters.previousRowsPerPageValue) {
            value = this.props.clusters.previousRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }

    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsPerPageState(value))
        this.dropUpManager()
    }

     createCSVData(csvData) {
        let ticketList = []
        if (csvData) {
            ticketList = JSON.parse(JSON.stringify(csvData))
            ticketList = createXLSheetdata(ticketList)
        }
        this.CSVData = ticketList
    }



   

    createCustomToolBar = props => {


        let clusterDetailsFilename = "clusters_data_" + moment().format("MM/DD/YYYY") + "-" +
            moment().format("h:mm:ss") + ".csv"
        return (
            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>
                <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 header-div-margins">
                   
                  

                    {(() =>{

                    if(Helpers.checkPrivileges("/dashboard/clusters/addEdit",this.props.user)){
                    return(
                     <div className="col-md-4 col-sm-12 col-xs-12 div-margins">
                   <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                e.preventDefault()

                                this.props.dispatch(clusterIdForAction())
                                this.props.history.push("/dashboard/clusters/addEdit")
                            }}>
                            Add
                        </button>
                        <CSVLink
                            data={this.CSVData}
                            className="btn btn-primary button-custom"
                            style={{ marginLeft: "10px",background: "#3c8dbc",border:"1px solid #3c8dbc"}}
                            filename={clusterDetailsFilename}>
                            Export
                        </CSVLink>
                    </div>
                    )
                }
            })()}
                </div>
                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 header-search-icon header-div-margins">
                    {props.components.searchPanel}
                </div>
            </div>
        )
    }


      expandComponent = row => {
        let row_id = ""
        if (row && row.id) {
            row_id = row.id
        }
        return <KitchensCollapsibleRow row={row} row_id={row_id} />
    }

    isExpandableRow = row => {
        return true
    }

    expandColumnComponent = ({ isExpandableRow, isExpanded }) => {
        let downIconClassName = ""
        if (isExpandableRow) {
            downIconClassName = (isExpanded ? 'fa fa-angle-double-up' : 'fa fa-angle-double-down')
        } else {
            downIconClassName = ""
        }
        return (
            <div className="custom-expandable-row-indicator">
                <span className={downIconClassName} />
            </div>
        )
    }
    

     
    createCustomFooter = props => {
        return(
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "18px" }}>
                    {props.components.sizePerPageDropdown}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "24px",textAlign:"center"}}>
                    {(() => {
                        if(this.state.clusterData.length>=(this.props.clusters.previousPaginationValue*this.props.clusters.previousRowsPerPageValue)){
                            return (
                            <p>
                               Showing {(this.props.clusters.previousPaginationValue*this.props.clusters.previousRowsPerPageValue)-this.props.clusters.previousRowsPerPageValue+1} to {this.props.clusters.previousPaginationValue*this.props.clusters.previousRowsPerPageValue} of {this.state.clusterData.length} results
                            </p>
                            )
                        }else{
                            return (
                            <p>
                               Showing {(this.props.clusters.previousPaginationValue*this.props.clusters.previousRowsPerPageValue)-this.props.clusters.previousRowsPerPageValue+1} to {this.state.clusterData.length} of {this.state.clusterData.length} results
                            </p>
                            )
                        }
                    })()}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 footer-pagination-icons">
                   {props.components.pageList}
                </div>
            </div> 
        )   
    }

    getFilteredClusterList = () => {
       
        this.props.dispatch(clusterTableReady(false))
        this.resetSearchAndPagination()
        this.getClustersData()
       
    }

    resetSearchAndPagination = () => {
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
        this.resetPagination()
    }

    
    resetFilterValues = () => {
        this.resetPagination()
        this.getClustersData()
        this.props.dispatch(clusterTableReady(false))
        this.props.dispatch(searchTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
    }

    actionButtonsCreator = (cell, row) => {
        let editButton =""

        if(Helpers.checkPrivileges("/dashboard/clusters/addEdit",this.props.user)){
        
            editButton=<button
                className="action-button"
                style={{ width: "70px", marginBottom: "1px" }}
                onClick={(e) => {
                    e.preventDefault()
                    this.editCluster(row)
                }}>
                Edit
            </button>
        }

        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{editButton}</div>
        </div>)
    }

     onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationState(page))
        this.setState({
            page: page
        })
    }

    resetPagination = () => {
        if (this.props.clusters && this.props.clusters.previousPaginationValue
            && this.props.clusters.previousPaginationValue !== 1) {
            this.props.dispatch(paginationState(1))
            this.setState({
                page: 1
            })
        }
    }

    editCluster = (row) => {
        if (row && row.id) {
            this.props.dispatch(clusterIdForAction(row.id))
            this.props.history.push("/dashboard/clusters/addEdit")
        } else {
            this.dialog.show({
                title: "Cluster Identification number not found",
                body: 'Cluster id is not available, So not able edit cluster',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }

    render() {
        let sizeperPage = 15

        if (this.props.clusters && this.props.clusters.previousRowsPerPageValue) {
            sizeperPage = this.props.clusters.previousRowsPerPageValue
        }

        const options = {
            page: this.state.page,  // which page you want to show as default
            sizePerPage: sizeperPage,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPageListPosition: 'bottom',
            sizePerPageDropDown: this.rowsperPageDropdown,
            searchPanel: (props) => (<SearchField { ...props }
                callback={this.resetPagination}
                ref={el => this.searchBox = el} />),
            toolBar: this.createCustomToolBar,
            paginationPanel: this.createCustomFooter,
            onlyOneExpanding: true,
            expandRowBgColor: '#e1e5ed',
            expandBy: 'column',  //Available value is row and column, default is row.
            onPageChange: this.onPageChange,
        }
        return (
            <div className="clusters-table" style={{ marginBottom: '0px', maxHeight: this.state.bodyHeight }}>
                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    ref='table'
                    options={options}
                    data={this.state.clusterData}
                    pagination={true}
                    expandableRow={this.isExpandableRow}
                    expandComponent={this.expandComponent}
                    hover={false}
                    search={true}
                    headerStyle={{ border: '0px', background: '#626262', color: '#fff' }}
                    tableStyle={{ border: '0px', 'background': 'white' }}
                    bodyStyle={{ border: '0px', overflow: "auto", height: this.state.tableHeight}}
                    expandColumnOptions={{
                        expandColumnVisible: true,
                        rerenderOnDataChange: true,
                        expandColumnComponent: this.expandColumnComponent
                    }}>
                    {(() =>{
                        if(Helpers.checkPrivileges("/dashboard/tech/only/access",this.props.user)){
                                return(     
                                       <TableHeaderColumn
                                            dataField="id"
                                            width="80"
                                            dataSort={true}
                                            isKey={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            ID
                                        </TableHeaderColumn>
                                    )
                                }else{
                                    return(
                                        <TableHeaderColumn
                                            dataField="id"
                                            width="1"
                                            isKey={true}
                                            hidden={true}
                                            expandable={false}
                                            dataAlign='center'
                                            tdStyle={{ whiteSpace: 'normal' }}>
                                            Id
                                        </TableHeaderColumn>
                                    )
                                }
                        })()}

                    <TableHeaderColumn
                        dataField="cluster_name"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Name
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="cluster_code"
                        
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                      Code
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="manager_name"
                        
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Manager
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="city_name"
                        
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        City
                    </TableHeaderColumn>
                    
                    
                    
                    
                     <TableHeaderColumn
                        dataField="id"
                        dataFormat={this.actionButtonsCreator}
                        filterFormatted={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Actions
                    </TableHeaderColumn>
                </BootstrapTable>
            </div>
        )
    }

}
const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        clusters: state.clusters
    }
}

export default connect(mapStateToProps)(withRouter(ClustersTable))


// WEBPACK FOOTER //
// ./src/modules/Clusters/Components/ClustersTable.js